module.exports = __webpack_public_path__ + "static/media/project_3.6ab412a9.png";